"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIGHT_THEME = exports.DARK_THEME = void 0;
var DARK_THEME = exports.DARK_THEME = 'DARK_THEME';
var LIGHT_THEME = exports.LIGHT_THEME = 'LIGHT_THEME';